import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-3 gap-[25px]" }
const _hoisted_2 = { class: "lg:col-span-2" }
const _hoisted_3 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_4 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_5 = { class: "trezo-card-title" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "trezo-card-content" }
const _hoisted_8 = {
  key: 0,
  class: "flex justify-center py-8"
}
const _hoisted_9 = {
  key: 1,
  class: "p-4 bg-red-100 text-red-700 rounded mb-4"
}
const _hoisted_10 = {
  key: 2,
  class: "sm:grid sm:grid-cols-2 sm:gap-[25px]"
}
const _hoisted_11 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_12 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_15 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_16 = { value: "" }
const _hoisted_17 = { value: "Digital Product" }
const _hoisted_18 = { value: "Physical Product" }
const _hoisted_19 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_20 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "sm:col-span-2 mb-[20px] sm:mb-0" }
const _hoisted_23 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_24 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_25 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_28 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_31 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = { class: "mb-[20px] sm:mb-0" }
const _hoisted_34 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_35 = ["placeholder"]
const _hoisted_36 = { class: "text-xs text-gray-500 dark:text-gray-400 mt-1 block" }
const _hoisted_37 = { class: "sm:col-span-2 mb-[20px] sm:mb-0" }
const _hoisted_38 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_39 = { class: "flex items-center gap-4" }
const _hoisted_40 = {
  key: 0,
  class: "w-24 h-24 rounded overflow-hidden"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = { id: "fileUploader" }
const _hoisted_43 = { class: "relative flex items-center justify-center overflow-hidden rounded-md py-4 px-[20px] border border-gray-200 dark:border-[#172036]" }
const _hoisted_44 = { class: "flex items-center justify-center" }
const _hoisted_45 = { class: "leading-[1.5]" }
const _hoisted_46 = { class: "text-black dark:text-white" }
const _hoisted_47 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_48 = {
  key: 0,
  class: "text-blue-500"
}
const _hoisted_49 = {
  key: 1,
  class: "text-green-500"
}
const _hoisted_50 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_51 = {
  key: 0,
  class: "flex justify-end mt-6"
}
const _hoisted_52 = { class: "lg:col-span-1" }
const _hoisted_53 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_54 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_55 = { class: "trezo-card-title" }
const _hoisted_56 = { class: "mb-0" }
const _hoisted_57 = { class: "trezo-card-content" }
const _hoisted_58 = { class: "mb-[20px] md:mb-[25px] last:mb-0" }
const _hoisted_59 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_60 = ["placeholder"]
const _hoisted_61 = { class: "flex flex-wrap gap-2 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.directT('ecommerce.createProduct.addProduct')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[11] || (_cache[11] = [
                  _createElementVNode("div", { class: "inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary-500 border-r-transparent" }, null, -1)
                ])))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.directT('ecommerce.createProduct.productTitle')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        placeholder: _ctx.directT('ecommerce.createProduct.productTitlePlaceholder'),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product.title) = $event))
                      }, null, 8, _hoisted_13), [
                        [_vModelText, _ctx.product.title]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.directT('ecommerce.createProduct.productType')), 1),
                      _withDirectives(_createElementVNode("select", {
                        class: "h-[55px] rounded-md border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[13px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.product_type) = $event))
                      }, [
                        _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.directT('ecommerce.createProduct.selectType')), 1),
                        _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.directT('ecommerce.createProduct.digitalProduct')), 1),
                        _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.directT('ecommerce.createProduct.physicalProduct')), 1)
                      ], 512), [
                        [_vModelSelect, _ctx.product.product_type]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.directT('ecommerce.createProduct.category')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        placeholder: _ctx.directT('ecommerce.createProduct.categoryPlaceholder'),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.category) = $event))
                      }, null, 8, _hoisted_21), [
                        [_vModelText, _ctx.product.category]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.directT('ecommerce.createProduct.description')), 1),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.description) = $event)),
                        class: "h-[179px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] p-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                      }, null, 512), [
                        [_vModelText, _ctx.product.description]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.directT('ecommerce.createProduct.regularPrice')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        placeholder: _ctx.directT('ecommerce.createProduct.regularPricePlaceholder'),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.price) = $event))
                      }, null, 8, _hoisted_26), [
                        [_vModelText, _ctx.product.price]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.directT('ecommerce.createProduct.salePrice')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        placeholder: _ctx.directT('ecommerce.createProduct.salePricePlaceholder'),
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.product.compare_at_price) = $event))
                      }, null, 8, _hoisted_29), [
                        [_vModelText, _ctx.product.compare_at_price]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.directT('ecommerce.createProduct.productLink')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        placeholder: _ctx.directT('ecommerce.createProduct.productLinkPlaceholder'),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.product.product_link) = $event))
                      }, null, 8, _hoisted_32), [
                        [_vModelText, _ctx.product.product_link]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.directT('ecommerce.createProduct.meetingTime')), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.product.time) = $event)),
                        placeholder: _ctx.directT('ecommerce.createProduct.meetingTimePlaceholder')
                      }, null, 8, _hoisted_35), [
                        [_vModelText, _ctx.product.time]
                      ]),
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.directT('ecommerce.createProduct.meetingTimeHint')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.directT('ecommerce.createProduct.productImage')), 1),
                      _createElementVNode("div", _hoisted_39, [
                        (_ctx.product.image_link)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("img", {
                                src: _ctx.product.image_link,
                                alt: "Product image",
                                class: "w-full h-full object-cover"
                              }, null, 8, _hoisted_41)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "w-[35px] h-[35px] border border-gray-100 dark:border-[#15203c] flex items-center justify-center rounded-md text-primary-500 text-lg ltr:mr-[12px] rtl:ml-[12px]" }, [
                                _createElementVNode("i", { class: "ri-upload-2-line" })
                              ], -1)),
                              _createElementVNode("p", _hoisted_45, [
                                _createElementVNode("strong", _hoisted_46, _toDisplayString(_ctx.directT('ecommerce.createProduct.clickToUpload')), 1),
                                _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.createProduct.image')), 1)
                              ])
                            ]),
                            _createElementVNode("input", {
                              type: "file",
                              id: "fileInput",
                              class: "absolute top-0 left-0 right-0 bottom-0 rounded-md z-[1] opacity-0 cursor-pointer",
                              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                              accept: "image/*"
                            }, null, 32)
                          ])
                        ]),
                        (_ctx.uploadStatus)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              (_ctx.uploadStatus === 'uploading')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.directT('ecommerce.createProduct.uploading')), 1))
                                : (_ctx.uploadStatus === 'success')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.directT('ecommerce.createProduct.uploadSuccess')), 1))
                                  : (_ctx.uploadStatus === 'error')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.directT('ecommerce.createProduct.uploadFailed')), 1))
                                    : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
          ]),
          (!_ctx.loading && !_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("button", {
                  type: "button",
                  class: "bg-primary-500 text-white px-6 py-2 rounded-md hover:bg-primary-600 transition-colors",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveProduct && _ctx.saveProduct(...args)))
                }, _toDisplayString(_ctx.directT('ecommerce.createProduct.createProductButton')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("h5", _hoisted_56, _toDisplayString(_ctx.directT('ecommerce.createProduct.tags')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.directT('ecommerce.createProduct.tags')), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                placeholder: _ctx.directT('ecommerce.createProduct.tagsPlaceholder'),
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tagsInput) = $event))
              }, null, 8, _hoisted_60), [
                [_vModelText, _ctx.tagsInput]
              ]),
              _createElementVNode("div", _hoisted_61, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedTags, (tag, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: "bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded text-sm"
                  }, _toDisplayString(tag), 1))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}